const REDEEM_STEPS = Object.freeze({
  ACTIVATION_CODE: 0,
  PERSONAL_INFO: 1,
  TERMS_CONDS: 2
})

export default REDEEM_STEPS



// WEBPACK FOOTER //
// ./src/constants/registration/redeemSteps.js